/**
 * Provides panorama math functions for calottes, spheres , etc.
 * @class PanoUtils
 * @static
 * @constructor
 */
export class PanoUtils {
    /**
     * Greater circle distance on sphere
     * @param {number[]} latlonA
     * @param {number[]} latlonB
     * @return {number} radius
     */
    static getDistanceOnSphere(latlonA, latlonB, radius) {
        const latA = (latlonA[0] * Math.PI) / 180;
        const lonA = (latlonA[1] * Math.PI) / 180;
        const latB = (latlonB[0] * Math.PI) / 180;
        const lonB = (latlonB[1] * Math.PI) / 180;
        // Distanz auf Grosskreis: https://de.wikipedia.org/wiki/Gro%C3%9Fkreis
        // lat = Breite = phi
        // lon = Laenge = lambda
        let d = Math.acos(Math.sin(latA) * Math.sin(latB) + Math.cos(latA) * Math.cos(latB) * Math.cos(lonB - lonA));
        d = d * radius;
        return d;
    }
}
//# sourceMappingURL=panoutils.js.map